import { createRouter, createWebHistory } from "vue-router";
import { useEventStore } from "@/stores/event";
import { useCurrentStore } from "@/stores/current";
import { useWebRTCStore } from "@/stores/webrtc";
import BaseView from "@/views/BaseView.vue";

const routes = [
  {
    path: "/",
    component: BaseView,
    children: [
      {
        path: "",
        component: () => import("@/views/ChannelsView.vue"),
        name: "home",
      },
      {
        path: "listen",
        component: () => import("@/views/ListenView.vue"),
        name: "listen",
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (from.name === "listen" && useCurrentStore().channel) {
    useCurrentStore().setChannel(null);
    useWebRTCStore().stopStream();
    const audio = document.getElementById("remoteAudio");
    if (audio && !audio.paused && audio.srcObject) audio.pause();
  }
  if (to.name === "listen" && !useCurrentStore().channel) {
    return next({
      name: "home",
      params: { eventSlug: to?.params?.eventSlug },
    });
  }
  return next();
});

router.afterEach((to) => {
  useEventStore().setSlug(to.params.eventSlug);
});

export default router;
